export class UserKycCountResponse {
    result?: number;
    message?: string;
    data?: UserKycCount = new UserKycCount();
}

export class UserKycCount {
    started?: number = 0;
    failed?: number = 0;
    expired?: number = 0;
    completed?: number = 0;
    checking?: number = 0;
    ready?: number = 0;
    amlblock?: number = 0;
    icc?: number = 0;
}


// WEBPACK FOOTER //
// ./src/app/response/userkyccount.ts